module.exports = __webpack_public_path__ + "img/cursor.18eeee00.gif";